import 'react';
import styled from 'styled-components';
import { jsx } from 'react/jsx-runtime';
function Icon() {
  return /*#__PURE__*/jsx("svg", {
    width: "14",
    height: "10",
    viewBox: "0 0 14 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/jsx("path", {
      d: "M1 5.36364L4.75 9L13 1",
      stroke: "white",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })
  });
}
const CheckIcon = styled(Icon)`
  fill: ${({
  theme
}) => theme.colors.onPrimary};
  cursor: pointer;
`;
export { CheckIcon as default };
//# sourceMappingURL=CheckIcon.js.map
